import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/sify-voiceover/page.tsx");
